// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Env = require("./reason/common/Env.bs.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let AuthSession = require("./utils/AuthSession.bs.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let RelayRuntime = require("relay-runtime");
let Stdlib_Promise = require("@rescript/runtime/lib/js/Stdlib_Promise.js");
let GraphQLWSClient = require("./GraphQLWSClient.bs.js");
let Stdlib_Nullable = require("@rescript/runtime/lib/js/Stdlib_Nullable.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RelayNetworkUtils = require("./RelayNetworkUtils.bs.js");

function fetchQuery(operation, variables, _cacheConfig, _uploadables) {
  let match = operation.text;
  if (match !== null && match !== undefined) {
    return RelayRuntime.Observable.create(sink => {
      let cancelled = {
        contents: false
      };
      let currentSubscription = {
        contents: undefined
      };
      let run = async () => {
        let token = await AuthSession.getWithExpiryCheck(operation.name);
        if (cancelled.contents) {
          return;
        }
        let headers = Object.fromEntries(Belt_Array.concatMany([
          [[
              "content-type",
              "application/json"
            ]],
          token !== undefined ? [[
                "Authorization",
                `Bearer ` + token
              ]] : []
        ]));
        let source = RelayNetworkUtils.fetchGraphQL(Env.apiPath + `/graphql`, headers, operation, variables);
        let subscription = source.subscribe({
          next: value => {
            if (!cancelled.contents) {
              return sink.next(value);
            }
          },
          error: error => {
            if (!cancelled.contents) {
              return sink.error(error);
            }
          },
          complete: () => {
            if (!cancelled.contents) {
              return sink.complete();
            }
          }
        });
        currentSubscription.contents = subscription;
      };
      Stdlib_Promise.$$catch(run(), error => {
        if (!cancelled.contents) {
          sink.error(error);
        }
        return Promise.resolve();
      });
      return {
        unsubscribe: () => {
          cancelled.contents = true;
          let subscription = currentSubscription.contents;
          if (subscription !== undefined) {
            return subscription.unsubscribe();
          }
        },
        closed: false
      };
    });
  }
  match === null;
  return RelayRuntime.Observable.create(sink => {
    sink.next(Object.fromEntries([[
        "data",
        Object.fromEntries([])
      ]]));
    sink.complete();
  });
}

let network = RelayRuntime.Network.create(fetchQuery, Primitive_option.toUndefined(Stdlib_Option.map(GraphQLWSClient.client, wsClient => ((operation, variables, _cacheConfig) => {
  let subscriptionQuery_operationName = operation.name;
  let subscriptionQuery_query = Stdlib_Nullable.getOr(operation.text, "");
  let subscriptionQuery = {
    operationName: subscriptionQuery_operationName,
    query: subscriptionQuery_query,
    variables: variables
  };
  return RelayRuntime.Observable.create(sink => {
    let unsubscribe = wsClient.subscribe(subscriptionQuery, sink);
    return {
      unsubscribe: unsubscribe,
      closed: false
    };
  });
}))));

let environment = RescriptRelay.Environment.make(network, RescriptRelay.Store.make(new RelayRuntime.RecordSource(), 10, undefined), (nodeObj, param) => nodeObj.nodeId, undefined, undefined, undefined, undefined);

exports.environment = environment;
/* network Not a pure module */
